import ResourcesTypeSelect from './_ResourcesTypeSelect';

export default ResourcesTypeSelect;
